<template>
    <div style="min-height:700px;overflow: hidden;overflow-x:hidden">
        <individual-application-review v-if="isCompany == 'individual'" :data="data" @status-changed="statusChanged" />
        <developer-company-application-review v-if="isCompany == 'developer_company' || isCompany == 'developer'" :data="data" @status-changed="statusChanged" />
        <contractor-goods-application-review v-if="isCompany == 'contractor_goods'" :data="data" @status-changed="statusChanged"/>
        <contractor-works-application-review v-if="isCompany == 'contractor_works'" :data="data" @status-changed="statusChanged"/>
        <company-application-review v-if="isCompany == 'construction_company'" :data="data" @status-changed="statusChanged" />
    </div>
</template>

<script>
import { individualEnlistmentClient, companyEnlistmentClient } from "../api/config.js";
import { toastMixin } from "../mixins/ToastMixin.js";
import IndividualApplicationReview from "../views/applications/application-review/IndividualApplicationReview.vue";
import DeveloperCompanyApplicationReview from "../views/applications/application-review/DeveloperCompanyApplicationReview.vue";
import ContractorGoodsApplicationReview from "../views/applications/application-review/ContractorGoodsApplicationReview.vue";
import ContractorWorksApplicationReview from "../views/applications/application-review/ContractorWorksApplicationReview.vue";
import CompanyApplicationReview from "../views/applications/application-review/CompanyApplicationReview.vue";
export default {
    name: "ApplicationReviewPage",
    mixins: [ toastMixin ],
    components:{
        IndividualApplicationReview,
        DeveloperCompanyApplicationReview,
        ContractorGoodsApplicationReview,
        ContractorWorksApplicationReview,
        CompanyApplicationReview,
    },
    props:{
        type: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            data: {},
            isLoading: false
        }
    },
    computed:{
        isCompany(){
            console.log(this.type);
            if (this.type == "pending-construction_company" || this.type == "enlisted-construction_company" ||  this.type =="rejected-construction_company"){
                return "construction_company";
            } else if (this.type == "pending-developer_company" || this.type == "pending1-developer_company" || this.type == "pending2-developer_company" || this.type == "enlisted-developer_company" ||  this.type =="rejected-developer_company"){
                return "developer_company"
            } else if (this.type == "pending-developer" || this.type == "pending1-developer" || this.type == "pending2-developer" || this.type == "enlisted-developer" ||  this.type =="rejected-developer"){
                return "developer"
            } else if (this.type == "pending-contractor_goods" || this.type == "pending1-contractor_goods" || this.type == "pending2-contractor_goods" || this.type == "enlisted-contractor_goods" ||  this.type =="rejected-contractor_goods"){
                return "contractor_goods"
            } else if (this.type == "pending-contractor_works" || this.type == "pending1-contractor_works" || this.type == "pending2-contractor_works" || this.type == "enlisted-contractor_works" ||  this.type =="rejected-contractor_works"){
                return "contractor_works"
            } else{
                return "individual";
            }
            return "";
        }
    },
    methods:{
        fethOneIndividual(id){
            individualEnlistmentClient.fetchOneById(id).then((res) => {
                this.isLoading = true;
                if (!res.networkError){
                    if (res.status == 200){
                        this.isLoading = false;
                        this.data = res.body;
                    }else{
                        this.errorToast(this.$t('toast-error-messages.error') + res.status);
                        this.isLoading = false;
                    }
                }else{
                    this.errorToast(this.$t('toast-error-messages.network-error'));
                    this.isLoading = false;
                }
            })
        },

        fetchOneDeveloper(id){
            companyEnlistmentClient.fetchOneById(id).then((res) => {
                this.isLoading = true;
                if (!res.networkError){
                    if (res.status == 200){
                        this.isLoading = false;
                        this.data = res.body;
                        // console.log(this.data);
                    }else{
                        this.errorToast(this.$t('toast-error-messages.error') + res.status);
                        this.isLoading = false;
                    }
                }else{
                    this.errorToast(this.$t('toast-error-messages.network-error'));
                    this.isLoading = false;
                }
            })
        },
        fetchOneCompany(id){
            companyEnlistmentClient.fetchOneById(id).then((res) => {
                this.isLoading = true;
                if (!res.networkError){
                    if (res.status == 200){
                        this.isLoading = false;
                        this.data = res.body;
                    }else{
                        this.errorToast(this.$t('toast-error-messages.error') + res.status);
                        this.isLoading = false;
                    }
                }else{
                    this.errorToast(this.$t('toast-error-messages.network-error'));
                    this.isLoading = false;
                }
            })
        },
        statusChanged(evt) {
            this.data.status = evt.status;
        }
    },
    mounted(){
        var id = this.$route.query.id;
        if (this.type == "pending-construction_company" || this.type == "pending1-construction_company" || this.type == "pending2-construction_company" || this.type == "enlisted-construction_company" ||  this.type =="rejected-construction_company"){
            this.fetchOneCompany(id);
        } else if (this.type == "pending-developer_company" || this.type == "pending1-developer_company" || this.type == "pending2-developer_company" || this.type == "enlisted-developer_company" ||  this.type =="rejected-developer_company"){
            this.fetchOneDeveloper(id);
        } else if (this.type == "pending-developer" || this.type == "pending1-developer" || this.type == "pending2-developer" || this.type == "enlisted-developer" ||  this.type =="rejected-developer"){
            this.fetchOneDeveloper(id);
        } else if (this.type == "pending-contractor_goods" || this.type == "pending1-contractor_goods" || this.type == "pending2-contractor_goods" || this.type == "enlisted-contractor_goods" ||  this.type =="rejected-contractor_goods"){
            this.fetchOneCompany(id);
        } else if (this.type == "pending-contractor_works" || this.type == "pending1-contractor_works" || this.type == "pending2-contractor_works" || this.type == "enlisted-contractor_works" ||  this.type =="rejected-contractor_works"){
            this.fetchOneCompany(id);
        } else {
            this.fethOneIndividual(id);
        }
    }
}
</script>

<style>

</style>